"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ATSceneNames {
}
ATSceneNames.Menu = "ATMenuScene";
ATSceneNames.Preload = "ATPreloadScene";
ATSceneNames.Game = "ATGameScene";
ATSceneNames.Audio = "ATAudioScene";
exports.default = ATSceneNames;
